(function () {

  const GLB_CACHE_BUST = 'rebxgrade=21';



  function bustModelUrl(url) {

    if (!url) return url;

    const sep = url.includes('?') ? '&' : '?';

    return `${url}${sep}${GLB_CACHE_BUST}`;

  }



  const GRADE_SLUGS = ['fair', 'good', 'very-good', 'excellent'];



  const DEVICE_GRADES = {

    smartphone: {

      fair: {

        screen: 'May have light scratches that are slightly visible when the device is on.',

        body: 'Signs of wear including visible scratches and dents on the body that do not affect performance.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Minimum 80% battery health. Suitable for everyday use with 12-month warranty.',

      },

      good: {

        screen: 'No scratches on the screen. Light micro-scratches on the body are not visible from arm\'s length.',

        body: 'Light signs of wear. Micro-scratches on the body are not visible from about 20 inches away.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Good battery health: minimum 80% capacity with reliable daily performance.',

      },

      'very-good': {

        screen: 'No scratches on the screen. Minimal to no visible marks when the device is on.',

        body: 'Almost no signs of wear. Very light micro-scratches, if any, are hard to spot up close.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Strong battery health: minimum 80% capacity with reliable daily performance.',

      },

      excellent: {

        screen: 'No scratches on the screen. Minimal to no visible marks when the device is on.',

        body: 'Almost no signs of wear. Very light micro-scratches, if any, are not visible from 8 inches away.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Strong battery performance with minimum 80% capacity for everyday use.',

      },

    },

    smartwatch: {

      fair: {

        screen: 'Display may show light scratches visible when the watch face is on.',

        body: 'Case and strap show visible wear, scuffs or scratches that do not affect performance.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Minimum 80% battery health. Suitable for everyday use with 12-month warranty.',

      },

      good: {

        screen: 'No scratches on the display. Light micro-scratches on the case are hard to see at arm\'s length.',

        body: 'Light signs of wear on the case or strap, not noticeable from about 20 inches away.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Good battery health: minimum 80% capacity with reliable daily performance.',

      },

      'very-good': {

        screen: 'No scratches on the display. Minimal to no visible marks when the watch face is on.',

        body: 'Almost no signs of wear on the case or strap. Any marks are hard to spot up close.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Strong battery health: minimum 80% capacity with reliable daily performance.',

      },

      excellent: {

        screen: 'No scratches on the display. Minimal to no visible marks when the watch face is on.',

        body: 'Almost no signs of wear on the case or strap. Very light marks, if any, are not visible from 8 inches away.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Strong battery performance with minimum 80% capacity for everyday use.',

      },

    },

    console: {

      fair: {

        screen: 'May show light scuffs or marks on the shell, panels or controller grips.',

        body: 'Visible wear on the casing or ports that does not affect performance.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'All essential functions tested. Power, inputs and storage verified where applicable.',

      },

      good: {

        screen: 'Light cosmetic marks only. Easy to overlook from normal viewing distance.',

        body: 'Minor signs of use on the shell or grips, not noticeable from arm\'s length.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Fully tested for reliable everyday use with our quality checks.',

      },

      'very-good': {

        screen: 'Minimal to no visible marks on shell, panels or controller surfaces.',

        body: 'Almost no signs of wear. Any marks are hard to spot up close.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Fully tested with strong performance across all key functions.',

      },

      excellent: {

        screen: 'Minimal to no visible cosmetic marks on the shell or controller.',

        body: 'Very light marks, if any, are not visible from normal viewing distance.',

        hardware:

          '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',

        battery: 'Fully tested and ready for everyday use.',

      },

    },

  };



  const DEVICE_LABELS = {

    smartphone: { screen: 'Screen', body: 'Body', icon: '📱' },

    smartwatch: { screen: 'Display', body: 'Case & strap', icon: '⌚' },

    console: { screen: 'Shell & panels', body: 'Ports & vents', icon: '🎮' },

  };



  const CONSOLE_PART_LABELS = {

    standing: { screen: 'Shell & panels', body: 'Ports & vents', icon: '🎮' },

    lying: { screen: 'Shell & panels', body: 'Ports & vents', icon: '🎮' },

    controller: { screen: 'Sticks & buttons', body: 'Grip & shell', icon: '🕹️' },

    console: { screen: 'Shell & panels', body: 'Ports & vents', icon: '🎮' },

  };



  const DEVICE_CAMERA = {

    smartphone: { orbit: '0deg 75deg 130%', fov: '28deg' },

    smartwatch: { orbit: '25deg 72deg 145%', fov: '30deg' },

    console: { orbit: '0deg 68deg 155%', fov: '30deg' },

  };



  const VALID_DEVICES = ['smartphone', 'smartwatch', 'console'];

  const PHONE_BRANDS = ['apple', 'samsung', 'google', 'default'];

  const CONSOLE_PLATFORMS = ['playstation'];

  const CONSOLE_PARTS = ['standing', 'lying', 'controller'];

  /** BLEND materials in some GLBs sort incorrectly in model-viewer (see-through at angles). */
  function fixViewerMaterials(viewerEl) {
    const materials = viewerEl.model?.materials;
    if (!materials?.length) return;

    for (const material of materials) {
      try {
        if (typeof material.setAlphaMode === 'function') {
          material.setAlphaMode('OPAQUE');
        }
        if (typeof material.setDoubleSided === 'function') {
          material.setDoubleSided(true);
        }
        const pbr = material.pbrMetallicRoughness;
        if (pbr?.baseColorFactor?.length === 4 && typeof pbr.setBaseColorFactor === 'function') {
          const [r, g, b] = pbr.baseColorFactor;
          pbr.setBaseColorFactor([r, g, b, 1]);
        }
        if (typeof material.setEmissiveFactor === 'function') {
          material.setEmissiveFactor([0, 0, 0]);
        }
      } catch (_) {
        /* scene-graph API unavailable */
      }
    }
  }

  function getModelUrl(device, grade, phoneBrand, consolePlatform, consolePart) {

    const assets = window.rebxPromiseAssets?.[device];

    if (!assets) return '';

    if (device === 'smartphone') {

      const brand = PHONE_BRANDS.includes(phoneBrand) ? phoneBrand : 'default';

      const brandAssets = assets[brand] || assets.default;

      return brandAssets?.[grade] || brandAssets?.fair || '';

    }

    if (device === 'console') {

      const platform = CONSOLE_PLATFORMS.includes(consolePlatform) ? consolePlatform : 'playstation';

      let part = CONSOLE_PARTS.includes(consolePart) ? consolePart : 'standing';

      if (consolePart === 'console') part = 'standing';

      const platformAssets = assets[platform] || assets.playstation;

      const partAssets = platformAssets?.[part] || platformAssets?.standing;

      return partAssets?.[grade] || partAssets?.fair || '';

    }

    return assets[grade] || '';

  }



  function setupMagnifier(viewerEl, stageEl, wrapEl, magnifyToggle, ensureViewerActive) {

    if (!viewerEl || !stageEl || !wrapEl) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const lens = stageEl.querySelector('[data-magnifier-lens]');

    const lensCanvas = stageEl.querySelector('[data-magnifier-canvas]');

    if (!lens || !lensCanvas) return;

    const ctx = lensCanvas.getContext('2d', { alpha: false });

    if (!ctx) return;

    const canvasSize = lensCanvas.width;

    const zoom = 2.25;

    const captureIntervalMs = 160;

    const finePointerHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    let rafId = null;

    let captureTimer = null;

    let captureInFlight = false;

    let cachedBitmap = null;

    let lastPointer = null;

    let activePointerId = null;

    let hoverCameraSuspended = false;

    function canMagnify() {

      return wrapEl.classList.contains('is-active');

    }

    function magnifyModeOn() {

      return wrapEl.classList.contains('is-magnify-mode');

    }

    function syncCameraControls() {

      if (magnifyModeOn() || hoverCameraSuspended) {

        viewerEl.removeAttribute('camera-controls');

        return;

      }

      viewerEl.setAttribute('camera-controls', '');

    }

    function setHoverCameraSuspended(on) {

      if (magnifyModeOn()) return;

      hoverCameraSuspended = on;

      syncCameraControls();

    }

    function isPointerOverViewer(event) {

      const rect = viewerEl.getBoundingClientRect();

      return (

        event.clientX >= rect.left &&

        event.clientX <= rect.right &&

        event.clientY >= rect.top &&

        event.clientY <= rect.bottom

      );

    }

    function shouldMagnify(pointerType) {

      if (!canMagnify()) return false;

      if (magnifyModeOn()) return true;

      return pointerType === 'mouse' && finePointerHover;

    }

    function useHoverMagnifier(pointerType) {

      return finePointerHover && pointerType === 'mouse' && !magnifyModeOn();

    }

    function releaseBitmap() {

      if (cachedBitmap) {

        cachedBitmap.close();

        cachedBitmap = null;

      }

    }

    async function exportSnapshotBlob() {

      if (viewerEl.updateComplete) {

        await viewerEl.updateComplete;

      }

      const exportOptions = { mimeType: 'image/jpeg', qualityArgument: 0.9 };

      if (typeof viewerEl.toBlob === 'function') {

        return viewerEl.toBlob(exportOptions);

      }

      if (typeof viewerEl.toDataURL === 'function') {

        const dataUrl = viewerEl.toDataURL('image/jpeg', 0.9);

        const response = await fetch(dataUrl);

        return response.blob();

      }

      return null;

    }

    async function captureFrame() {

      if (captureInFlight || !canMagnify()) return;

      captureInFlight = true;

      try {

        let blob = await exportSnapshotBlob();

        if (!blob || blob.size < 80) {

          blob = await exportSnapshotBlob();

        }

        if (!blob || blob.size < 80) return;

        const bitmap = await createImageBitmap(blob);

        releaseBitmap();

        cachedBitmap = bitmap;

      } catch (_) {

        /* model still loading or export blocked */

      } finally {

        captureInFlight = false;

      }

    }

    function scheduleDraw() {

      if (rafId != null) return;

      rafId = window.requestAnimationFrame(drawLens);

    }

    function drawLens() {

      rafId = null;

      if (!lastPointer || !wrapEl.classList.contains('is-magnifying') || !cachedBitmap) return;

      const viewerRect = viewerEl.getBoundingClientRect();

      if (viewerRect.width < 2 || viewerRect.height < 2) return;

      const stageRect = stageEl.getBoundingClientRect();

      const x = lastPointer.clientX - stageRect.left;

      const y = lastPointer.clientY - stageRect.top;

      lens.style.left = `${x}px`;

      lens.style.top = `${y}px`;

      const relX = Math.min(1, Math.max(0, (lastPointer.clientX - viewerRect.left) / viewerRect.width));

      const relY = Math.min(1, Math.max(0, (lastPointer.clientY - viewerRect.top) / viewerRect.height));

      const regionW = cachedBitmap.width / zoom;

      const regionH = cachedBitmap.height / zoom;

      let sx = relX * cachedBitmap.width - regionW / 2;

      let sy = relY * cachedBitmap.height - regionH / 2;

      sx = Math.max(0, Math.min(cachedBitmap.width - regionW, sx));

      sy = Math.max(0, Math.min(cachedBitmap.height - regionH, sy));

      ctx.clearRect(0, 0, canvasSize, canvasSize);

      ctx.save();

      ctx.beginPath();

      ctx.arc(canvasSize / 2, canvasSize / 2, canvasSize / 2, 0, Math.PI * 2);

      ctx.closePath();

      ctx.clip();

      ctx.drawImage(cachedBitmap, sx, sy, regionW, regionH, 0, 0, canvasSize, canvasSize);

      ctx.restore();

    }

    function startCaptureLoop() {

      stopCaptureLoop();

      captureTimer = window.setInterval(() => {

        if (!wrapEl.classList.contains('is-magnifying')) {

          stopCaptureLoop();

          return;

        }

        captureFrame().then(() => {

          if (wrapEl.classList.contains('is-magnifying')) scheduleDraw();

        });

      }, captureIntervalMs);

    }

    function stopCaptureLoop() {

      if (captureTimer != null) {

        window.clearInterval(captureTimer);

        captureTimer = null;

      }

    }

    function showMagnifier(event) {

      if (!shouldMagnify(event.pointerType)) return;

      lastPointer = event;

      wrapEl.classList.add('is-magnifying');

      lens.classList.add('is-visible');

      lens.setAttribute('aria-hidden', 'false');

      captureFrame().then(() => {

        scheduleDraw();

        startCaptureLoop();

      });

    }

    function moveMagnifier(event) {

      if (!wrapEl.classList.contains('is-magnifying')) return;

      lastPointer = event;

      scheduleDraw();

    }

    function hideMagnifier() {

      lastPointer = null;

      activePointerId = null;

      wrapEl.classList.remove('is-magnifying');

      lens.classList.remove('is-visible');

      lens.setAttribute('aria-hidden', 'true');

      setHoverCameraSuspended(false);

      stopCaptureLoop();

      releaseBitmap();

      if (rafId != null) {

        window.cancelAnimationFrame(rafId);

        rafId = null;

      }

    }

    function setMagnifyMode(on) {

      wrapEl.classList.toggle('is-magnify-mode', on);

      magnifyToggle?.classList.toggle('is-pressed', on);

      magnifyToggle?.setAttribute('aria-pressed', on ? 'true' : 'false');

      if (on) {

        hoverCameraSuspended = false;

        viewerEl.setAttribute('touch-action', 'none');

      } else {

        viewerEl.setAttribute('touch-action', 'pan-y');

        hideMagnifier();

      }

      syncCameraControls();

    }

    magnifyToggle?.addEventListener('click', () => {

      if (!canMagnify() && typeof ensureViewerActive === 'function') {

        ensureViewerActive();

      }

      if (!canMagnify()) return;

      setMagnifyMode(!magnifyModeOn());

    });

    viewerEl.addEventListener(

      'pointerdown',

      (event) => {

        if (!shouldMagnify(event.pointerType)) return;

        if (useHoverMagnifier(event.pointerType)) return;

        activePointerId = event.pointerId;

        try {

          viewerEl.setPointerCapture(event.pointerId);

        } catch (_) {

          /* ignore */

        }

        showMagnifier(event);

      },

      { capture: true, passive: true }

    );

    viewerEl.addEventListener(

      'pointermove',

      (event) => {

        if (!canMagnify()) return;

        if (useHoverMagnifier(event.pointerType)) return;

        if (wrapEl.classList.contains('is-magnifying')) {

          moveMagnifier(event);

          return;

        }

        if (activePointerId === event.pointerId && event.pointerType !== 'mouse') {

          showMagnifier(event);

        }

      },

      { capture: true, passive: true }

    );

    function endPointer(event) {

      if (useHoverMagnifier(event.pointerType)) return;

      if (activePointerId != null && event.pointerId !== activePointerId) return;

      try {

        if (viewerEl.hasPointerCapture?.(event.pointerId)) {

          viewerEl.releasePointerCapture(event.pointerId);

        }

      } catch (_) {

        /* ignore */

      }

      hideMagnifier();

    }

    viewerEl.addEventListener('pointerup', endPointer, { capture: true, passive: true });

    viewerEl.addEventListener('pointercancel', endPointer, { capture: true, passive: true });

    if (finePointerHover) {

      wrapEl.addEventListener('mousemove', (event) => {

        if (!canMagnify() || magnifyModeOn()) return;

        if (event.buttons !== 0) {

          hideMagnifier();

          return;

        }

        if (!isPointerOverViewer(event)) {

          hideMagnifier();

          return;

        }

        setHoverCameraSuspended(true);

        if (wrapEl.classList.contains('is-magnifying')) {

          moveMagnifier(event);

        } else {

          showMagnifier(event);

        }

      });

      wrapEl.addEventListener('mouseleave', () => {

        if (!magnifyModeOn()) hideMagnifier();

      });

      viewerEl.addEventListener(

        'mousedown',

        () => {

          if (!magnifyModeOn()) hideMagnifier();

        },

        { capture: true }

      );

    }

    viewerEl.addEventListener('load', () => {

      if (wrapEl.classList.contains('is-magnifying')) {

        captureFrame().then(scheduleDraw);

      }

    });

    return { hideMagnifier, setMagnifyMode };

  }



  function initPromiseGrading(root) {

    const viewer = root.querySelector('[data-rebx-model-viewer]');

    const viewerWrap = root.querySelector('[data-viewer-wrap]');

    const viewerStage = root.querySelector('[data-viewer-stage]');

    const activateBtn = root.querySelector('[data-viewer-activate]');

    const gradeTabs = root.querySelectorAll('[data-grade-tab]');

    const deviceTabs = root.querySelectorAll('[data-device-tab]');

    const detailScreen = root.querySelector('[data-detail="screen"]');

    const detailBody = root.querySelector('[data-detail="body"]');

    const detailHardware = root.querySelector('[data-detail="hardware"]');

    const detailBattery = root.querySelector('[data-detail="battery"]');

    const detailScreenLabel = root.querySelector('[data-detail-label="screen"]');

    const detailBodyLabel = root.querySelector('[data-detail-label="body"]');

    const detailScreenIcon = root.querySelector('[data-detail-icon="screen"]');

    const rotateLeft = root.querySelector('[data-rotate="left"]');

    const rotateRight = root.querySelector('[data-rotate="right"]');

    const resetView = root.querySelector('[data-reset-view]');

    const zoomIn = root.querySelector('[data-zoom="in"]');

    const zoomOut = root.querySelector('[data-zoom="out"]');

    const magnifyToggle = root.querySelector('[data-magnify-toggle]');

    const consolePartsEl = root.querySelector('[data-console-parts]');

    const consolePartTabs = root.querySelectorAll('[data-console-part]');



    if (!viewer || !gradeTabs.length) return;

    const deferModel = viewer.dataset.deferModel === 'true';

    const initialGrade = root.dataset.initialGrade || 'fair';

    const initialDevice = VALID_DEVICES.includes(root.dataset.initialDevice)
      ? root.dataset.initialDevice
      : 'smartphone';

    const initialPhoneBrand = PHONE_BRANDS.includes(root.dataset.phoneBrand)
      ? root.dataset.phoneBrand
      : 'default';

    const initialConsolePlatform = CONSOLE_PLATFORMS.includes(root.dataset.consolePlatform)
      ? root.dataset.consolePlatform
      : 'playstation';

    let initialConsolePart = root.dataset.consolePart || 'standing';

    if (initialConsolePart === 'console') initialConsolePart = 'standing';

    if (!CONSOLE_PARTS.includes(initialConsolePart)) initialConsolePart = 'standing';

    let activeDevice = initialDevice;

    let activePhoneBrand = initialPhoneBrand;

    let activeConsolePlatform = initialConsolePlatform;

    let activeConsolePart = initialConsolePart;

    let activeGrade = GRADE_SLUGS.includes(initialGrade) ? initialGrade : 'fair';



    function getCameraDefaults() {

      return DEVICE_CAMERA[activeDevice] || DEVICE_CAMERA.smartphone;

    }



    function resetCamera(viewerEl) {

      const camera = getCameraDefaults();

      viewerEl.setAttribute('camera-orbit', camera.orbit);

      viewerEl.setAttribute('field-of-view', camera.fov);

      if (typeof viewerEl.resetTurntableRotation === 'function') {

        viewerEl.resetTurntableRotation();

      }

      if (typeof viewerEl.jumpCameraToGoal === 'function') {

        viewerEl.jumpCameraToGoal();

      }

    }



    let magnifierApi = null;

    function shouldLoadModelNow() {
      return !deferModel || viewerWrap?.classList.contains('is-active');
    }

    async function prepareViewerAssets() {
      if (typeof window.rebxLoadGradingAssets === 'function') {
        try {
          await window.rebxLoadGradingAssets();
        } catch (_) {
          /* continue without 3D */
        }
      }
    }

    function setViewerActive(active, options) {

      if (!viewerWrap) return;

      const shouldFocus = options && options.focus === true;

      viewerWrap.classList.toggle('is-active', active);

      if (!active) {

        viewerWrap.classList.remove('is-magnifying', 'is-magnify-mode');

        magnifierApi?.setMagnifyMode(false);

        magnifierApi?.hideMagnifier();

      }

      viewer.removeAttribute('tabindex');

      if (active && shouldFocus) {

        viewer.setAttribute('tabindex', '0');

        try {

          viewer.focus({ preventScroll: true });

        } catch (_) {

          /* preventScroll unsupported — skip focus to avoid page jump */

        }

      }

    }



    viewer.addEventListener(

      'wheel',

      (event) => {

        if (!(event.metaKey || event.ctrlKey)) {

          event.stopPropagation();

        }

      },

      true

    );



    async function activateViewer(options) {
      if (viewerWrap) viewerWrap.classList.add('is-loading');
      try {
        await prepareViewerAssets();
        setViewerActive(true, options);
        if (deferModel) loadGrade(activeGrade);
      } finally {
        viewerWrap?.classList.remove('is-loading');
      }
    }

    function scheduleDeferredAutoActivate() {
      if (!deferModel) return;

      const run = () => activateViewer({ focus: false });

      if (!('IntersectionObserver' in window)) {
        run();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          run();
        },
        { threshold: 0.12, rootMargin: '0px' }
      );

      observer.observe(root);
    }

    activateBtn?.addEventListener('click', () => activateViewer({ focus: true }));



    document.addEventListener('click', (event) => {

      if (!viewerWrap?.classList.contains('is-active')) return;

      if (viewerWrap.contains(event.target)) return;

      setViewerActive(false);

    });



    document.addEventListener('keydown', (event) => {

      if (event.key === 'Escape') setViewerActive(false);

    });



    function setActiveGradeTab(grade) {

      gradeTabs.forEach((tab) => {

        tab.classList.toggle('is-active', tab.dataset.gradeTab === grade);

      });

    }



    function setActiveDeviceTab(device) {

      deviceTabs.forEach((tab) => {

        const isActive = tab.dataset.deviceTab === device;

        tab.classList.toggle('rebx-grading__device--active', isActive);

        tab.classList.remove('rebx-grading__device--soon');

        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');

      });

    }



    function setConsolePartsVisible(visible) {

      if (!consolePartsEl) return;

      consolePartsEl.hidden = !visible;

    }



    function setActiveConsolePartTab(part) {

      consolePartTabs.forEach((tab) => {

        const isActive = tab.dataset.consolePart === part;

        tab.classList.toggle('is-active', isActive);

        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');

      });

    }



    function updateDetailLabels(device, consolePart) {

      let labels = DEVICE_LABELS[device] || DEVICE_LABELS.smartphone;

      if (device === 'console') {

        labels =
          CONSOLE_PART_LABELS[consolePart] ||
          CONSOLE_PART_LABELS.standing ||
          CONSOLE_PART_LABELS.console;

      }

      if (detailScreenLabel) detailScreenLabel.textContent = labels.screen;

      if (detailBodyLabel) detailBodyLabel.textContent = labels.body;

      if (detailScreenIcon) detailScreenIcon.textContent = labels.icon;

    }



    function updateDetails(grade) {

      const data = DEVICE_GRADES[activeDevice]?.[grade];

      if (!data) return;



      if (detailScreen) detailScreen.textContent = data.screen;

      if (detailBody) detailBody.textContent = data.body;

      if (detailHardware) detailHardware.textContent = data.hardware;

      if (detailBattery) detailBattery.textContent = data.battery;

    }



    function loadGrade(grade) {

      const model = getModelUrl(
        activeDevice,
        grade,
        activePhoneBrand,
        activeConsolePlatform,
        activeConsolePart
      );

      const data = DEVICE_GRADES[activeDevice]?.[grade];

      if (!data || !model) return;



      activeGrade = grade;

      setActiveGradeTab(grade);

      updateDetails(grade);

      if (!shouldLoadModelNow()) return;

      const onLoad = () => {

        fixViewerMaterials(viewer);

        resetCamera(viewer);

        viewer.removeEventListener('load', onLoad);

      };

      viewer.addEventListener('load', onLoad);

      let altDevice = 'smartphone';

      if (activeDevice === 'smartwatch') altDevice = 'smartwatch';

      if (activeDevice === 'console') {

        if (activeConsolePart === 'controller') {
          altDevice = 'PlayStation controller';
        } else if (activeConsolePart === 'lying') {
          altDevice = 'PlayStation console lying down';
        } else {
          altDevice = 'PlayStation console standing';
        }

      }

      viewer.setAttribute(

        'alt',

        `Interactive 3D model showing RebX ${grade.replace('-', ' ')} ${altDevice} cosmetic grade`

      );

      viewer.setAttribute('src', bustModelUrl(model));

    }



    function loadConsolePart(part) {

      if (!CONSOLE_PARTS.includes(part) || activeDevice !== 'console') return;

      activeConsolePart = part;

      setActiveConsolePartTab(part);

      updateDetailLabels(activeDevice, activeConsolePart);

      loadGrade(activeGrade);

    }



    function loadDevice(device) {

      if (!DEVICE_GRADES[device]) return;

      activeDevice = device;

      if (device !== 'smartphone') {

        activePhoneBrand = 'default';

      }

      if (device === 'console') {

        setConsolePartsVisible(true);

        setActiveConsolePartTab(activeConsolePart);

      } else {

        setConsolePartsVisible(false);

        activeConsolePart = 'standing';

      }

      setActiveDeviceTab(device);

      updateDetailLabels(device, activeConsolePart);

      loadGrade(activeGrade);

    }



    function rotateModel(direction) {

      const step = direction === 'left' ? -30 : 30;

      const current = viewer.getCameraOrbit();

      const theta = current.theta + (step * Math.PI) / 180;

      viewer.cameraOrbit = `${theta}rad ${current.phi}rad ${current.radius}m`;

    }



    function zoomModel(direction) {

      if (typeof viewer.getCameraOrbit !== 'function') return;

      const current = viewer.getCameraOrbit();

      const scale = direction === 'in' ? 0.88 : 1.12;

      const newRadius = current.radius * scale;

      viewer.cameraOrbit = `${current.theta}rad ${current.phi}rad ${newRadius}m`;

      if (typeof viewer.jumpCameraToGoal === 'function') {

        viewer.jumpCameraToGoal();

      }

    }



    gradeTabs.forEach((tab) => {

      tab.addEventListener('click', () => {

        loadGrade(tab.dataset.gradeTab);

      });

    });



    deviceTabs.forEach((tab) => {

      if (tab.dataset.deviceTab === 'smartphone' || tab.dataset.deviceTab === 'smartwatch' || tab.dataset.deviceTab === 'console') {

        tab.setAttribute('role', 'tab');

        tab.classList.add('rebx-grading__device--selectable');

        tab.addEventListener('click', () => {

          loadDevice(tab.dataset.deviceTab);

        });

        tab.addEventListener('keydown', (event) => {

          if (event.key === 'Enter' || event.key === ' ') {

            event.preventDefault();

            loadDevice(tab.dataset.deviceTab);

          }

        });

      }

    });



    consolePartTabs.forEach((tab) => {

      tab.addEventListener('click', () => {

        loadConsolePart(tab.dataset.consolePart);

      });

    });



    rotateLeft?.addEventListener('click', () => rotateModel('left'));

    rotateRight?.addEventListener('click', () => rotateModel('right'));

    zoomIn?.addEventListener('click', () => zoomModel('in'));

    zoomOut?.addEventListener('click', () => zoomModel('out'));

    resetView?.addEventListener('click', () => resetCamera(viewer));



    setConsolePartsVisible(activeDevice === 'console');

    if (activeDevice === 'console') {

      setActiveConsolePartTab(activeConsolePart);

    }

    magnifierApi = setupMagnifier(viewer, viewerStage, viewerWrap, magnifyToggle, () => activateViewer({ focus: false }));

    if (root.dataset.viewerAutoActivate === 'true') {

      setViewerActive(true, { focus: false });

    }

    loadDevice(activeDevice);

  }



  function boot() {

    document.querySelectorAll('[data-rebx-grading], [data-rebx-promise-grading]').forEach(initPromiseGrading);

  }



  function start() {

    if (customElements.get('model-viewer')) {

      boot();

      return;

    }



    customElements.whenDefined('model-viewer').then(boot).catch(boot);

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', start);

  } else {

    start();

  }

})();

